import React, { useState } from "react";

import { ModalProps } from "@mui/material";
import { GeneralModal } from "components/modals/General-modal/GeneralModal";
import { useActionHook, useDidUpdate } from "hooks";
import { useUserActions } from "store";
import { IUsersContact } from "store/types";

import { ShareContent } from "./ShareContent";

export interface SharePopupProps extends Omit<ModalProps, "children"> {
  onClose: () => void;
  onInvite: (users: IUsersContact[], type: "guest" | "viewer", message: string) => void;
  // section: DocumentSection[];
}

export const SharePopup: React.FC<SharePopupProps> = ({ onClose, onInvite, ...modalProps }) => {
  const [selectedUsers, setSelectedUsers] = useState<Array<IUsersContact>>([]);
  const [shareType, setShareType] = useState<"guest" | "viewer">("viewer");
  const [message, setMessage] = useState<string>("");
  const [showMembersList, setShowMembersList] = useState(false);
  const [messageError, setMessageError] = useState<string>();

  const { getUsersContactAction } = useUserActions();

  const { action: getUsersForShare, data } = useActionHook(getUsersContactAction);

  useDidUpdate(() => {
    if (!modalProps.open) return;
    getUsersForShare();
  }, [modalProps.open]);

  const handleClose = () => {
    setMessage("");
    setMessageError("");
    setShareType("viewer");
    setSelectedUsers([]);
    setShowMembersList(false);
    onClose();
  };

  return (
    <GeneralModal
      title={showMembersList ? "Members" : "Share Element"}
      positiveBtn={{
        text: "Invite",
        onClick: () => {
          if (message) {
            onInvite(selectedUsers, shareType, message);
            handleClose();
          } else {
            setMessageError("Please enter a message");
          }
        }
      }}
      onClose={handleClose}
      {...modalProps}
    >
      {/* {showMembersList && section ? (
        <ShowMembers section={section} onBack={() => setShowMembersList(false)} />
      ) : ( */}
      <ShareContent
        shareType={shareType}
        setShareType={setShareType}
        sharableUsers={data || []}
        message={message}
        setMessage={(message) => {
          setMessageError("");
          setMessage(message);
        }}
        selectedUsers={selectedUsers}
        setSelectedUsers={setSelectedUsers}
        // showMembers={!!section}
        showMembers={showMembersList}
        onShowMembers={() => setShowMembersList(true)}
        messageError={messageError}
      />
      {/* )} */}
    </GeneralModal>
  );
};
